import React, { useState, useEffect, useMemo } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import SwapVert from "@mui/icons-material/SwapVert";
import _ from "lodash";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import CreateOrEditAmusementServiceReserveItemGroup from "./CreateOrEdit";
import ChangeOrderReserveItemGroup from "./ChangeOrderReserveItemGroup";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import Select from "react-select";
import { InputGroup, Button, FormControl, Col, Accordion, Card, Row, Spinner } from "react-bootstrap";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

const AmusementServiceReserveItemGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [services, setServices] = useState([]);
  const [showModalReserveItemGroup, setShowModalReserveItemGroup] = useState(false);
  const [showModalReserveItemGroupOrder, setShowModalReserveItemGroupOrder] = useState(false);
  const [selectedReserveItemGroupId, setSelectedReserveItemGroupId] = useState(null);
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };

  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const serviceIdFromUrl1 = searchParams.get("serviceId");

  const handleServiceChange = (event) => {
    if (event && event.length != 0)
      setValue("serviceId", { value: event.value, label: event.label });
    else {
      setValue("serviceId", null);
      searchParams.delete("serviceId")
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const result = await ApiAmusementServiceReserveItemGroup.getAll({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,

          globalSearch: searchParams.get("globalSearch"),

          serviceId: _.isEmpty(serviceIdFromUrl1) ? 0 : _.toString(serviceIdFromUrl1),
        });
        setListData(result);
        setValue("totalCount", result.totalCount);
        const data = await ApiAmusementService.getAllServices();

        if (data) {
          setServices(data);
        }
        const formInputs = [
          { name: "serviceId", type: "multiSelect", isMulti: false, data: data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    data.serviceId = !_.isEmpty(data.serviceId) ? data.serviceId?.value : null;
    const apiData = await ApiAmusementServiceReserveItemGroup.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
      serviceId: data.serviceId,
    });
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/amusementServiceReserveItemGroup?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-Items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت گروه های آیتم رزرو تفریحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست گروه های آیتم رزرو ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="mr-2"
              onClick={() => {
                setSelectedReserveItemGroupId(0);
                setShowModalReserveItemGroup(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد گروه آیتم رزرو جدید
            </Button>
            <Button
              variant="success"
              onClick={() => {
                setShowModalReserveItemGroupOrder(true);
              }}
            >
              <SwapVert className="mr-1" />
              ترتیب نمایش
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}

                <div className="">
                  {/* table */}
                  <Accordion>
                    <Card>
                      <Accordion.Header as={Card.Header}>
                        <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                      </Accordion.Header>
                      <Accordion.Body >
                        <Card.Body>
                          <Row>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2">
                              <Controller
                                name="serviceId"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="w-20 mt-2"
                                    placeholder="انتخاب تفریح"
                                    options={services?.map((item) => ({
                                      value: item.id,
                                      label: item.name,
                                      type: "service",
                                    }))}
                                    field={field}
                                    onChange={handleServiceChange}
                                  />
                                )}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col xs="12" className="tb-reponsive px-2">
                              <Button variant="success" type="submit" disabled={isSubmitting}>
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <SearchIcon />
                                جستجو
                              </Button>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Accordion.Body>
                    </Card>
                  </Accordion>
                  <InputGroup className="my-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />

                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>

                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    setShowModalReserveItemGroup={setShowModalReserveItemGroup}
                    setSelectedReserveItemGroupId={setSelectedReserveItemGroupId}
                  />
                </Col>
                {showModalReserveItemGroup && (
                  <CreateOrEditAmusementServiceReserveItemGroup
                    showModalReserveItemGroup={showModalReserveItemGroup}
                    setShowModalReserveItemGroup={setShowModalReserveItemGroup}
                    selectedReserveItemGroupId={selectedReserveItemGroupId}
                  />
                )}
                {showModalReserveItemGroupOrder && (
                  <ChangeOrderReserveItemGroup
                    showModalReserveItemGroupOrder={showModalReserveItemGroupOrder}
                    setShowModalReserveItemGroupOrder={setShowModalReserveItemGroupOrder}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmusementServiceReserveItemGroup;
